import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 bg-primary-500 rounded-lg flex items-center justify-center">
                <i className="ri-rainbow-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl font-semibold text-background-50">
                男同网站
              </span>
            </Link>
            <p className="text-secondary-200 text-sm leading-relaxed">
              安全、温暖的男同社区与交友平台，为每一个独特的你提供归属感。
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-secondary-200 hover:text-background-50 text-sm transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/jiaoyou" className="text-secondary-200 hover:text-background-50 text-sm transition-colors">
                  交友配对
                </Link>
              </li>
              <li>
                <Link to="/category/zixun" className="text-secondary-200 hover:text-background-50 text-sm transition-colors">
                  社区资讯
                </Link>
              </li>
              <li>
                <Link to="/category/huodong" className="text-secondary-200 hover:text-background-50 text-sm transition-colors">
                  活动聚会
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-secondary-200 hover:text-background-50 text-sm transition-colors">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-background-50 mb-4">支持服务</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/category/zhichi" className="text-secondary-200 hover:text-background-50 text-sm transition-colors">
                  心理支持
                </Link>
              </li>
              <li>
                <Link to="/category/jiankang" className="text-secondary-200 hover:text-background-50 text-sm transition-colors">
                  健康科普
                </Link>
              </li>
              <li>
                <Link to="/category/shenghuo" className="text-secondary-200 hover:text-background-50 text-sm transition-colors">
                  生活分享
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2.5 text-secondary-200 text-sm">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span>contact@nantongwangzhan.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                <span>400-888-9999</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line"></i>
                <span>北京市朝阳区彩虹大厦</span>
              </li>
            </ul>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 rounded-full bg-secondary-700 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-secondary-700 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-secondary-700 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="小红书">
                <i className="ri-reddit-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-secondary-700">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-5">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-secondary-300 text-xs">
              &copy; {new Date().getFullYear()} 男同网站 版权所有 | 京ICP备xxxxxxxx号
            </p>
            <div className="flex items-center gap-4 text-xs text-secondary-300">
              <a href="#" className="hover:text-background-50 transition-colors">隐私政策</a>
              <a href="#" className="hover:text-background-50 transition-colors">服务条款</a>
              <a href="#" className="hover:text-background-50 transition-colors">社区准则</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}